import base from "./base";

const config = Object.assign({}, base, {
  baseApi: "https://app-desa.cmr.limetropy.com/api/"
});

export default config;



// WEBPACK FOOTER //
// ./src/config/production.js